var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentNode } from './content-node';
var cls = classNames('slice-intro');
export var SliceIntroFontSizes = {
  small: 1,
  large: 2
};
export var SliceIntroDefaultProps = {
  variant: 'small'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: inherit;\n    text-align: center;\n    font-weight: 300;\n\n    p:last-child {\n      margin-bottom: 0;\n    } \n\n    b, strong {\n      color: inherit;\n    }\n    \n    ", "\n\n  "], ["\n    color: inherit;\n    text-align: center;\n    font-weight: 300;\n\n    p:last-child {\n      margin-bottom: 0;\n    } \n\n    b, strong {\n      color: inherit;\n    }\n    \n    ", "\n\n  "])), function (_a) {
    var variant = _a.variant;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: ", "em;\n    "], ["\n      font-size: ", "em;\n    "])), SliceIntroFontSizes[variant]);
  })
});
// -------- Components -------->
var My = {
  Container: styled(ContentNode)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SliceIntro = function (props) {
  var className = props.className,
    entity = props.entity,
    variant = props.variant;
  return React.createElement(My.Container, {
    variant: variant,
    entity: entity.intro,
    className: cls.name(className)
  });
};
SliceIntro.defaultProps = SliceIntroDefaultProps;
SliceIntro.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;